import { FC, useState } from 'react'
import { Box, Stack, Typography } from '@mui/material'
import AddIcon from '@mui/icons-material/Add'
import {
  NotionButton,
  PageScaffold,
} from '@/apps/latest/components/portal/notion'
import { PORTAL_TEXT } from '@/apps/latest/shared/styles/portalTypography'
import { useToast } from '@/shared/contexts'
import { useCreateTutorialPatientsMutation } from '@/features/internal/tutorial-patient'
import type { TutorialPatient } from '@/features/internal/tutorial-patient'

export const TutorialPage: FC = () => {
  const createMutation = useCreateTutorialPatientsMutation()
  const { showToast } = useToast()

  const [isSubmitting, setIsSubmitting] = useState(false)
  const [created, setCreated] = useState<TutorialPatient[] | null>(null)

  const handleCreate = async () => {
    setIsSubmitting(true)
    try {
      const result = await createMutation.mutateAsync()
      setCreated(result.created)
      showToast(`検証患者を ${result.count} 件作成しました`, 'success')
    } catch {
      showToast('検証患者の作成に失敗しました', 'error')
    } finally {
      setIsSubmitting(false)
    }
  }

  return (
    <PageScaffold title="チュートリアル">
      <Stack gap={2} sx={{ maxWidth: 560 }}>
        <Typography sx={PORTAL_TEXT.sectionDesc}>
          お試し用の患者を患者一覧に追加します。
        </Typography>

        <Box>
          <NotionButton
            variant="secondary"
            startIcon={<AddIcon />}
            onClick={handleCreate}
            disabled={isSubmitting}
          >
            検証患者を作成
          </NotionButton>
        </Box>

        {created && (
          <Typography sx={PORTAL_TEXT.sectionDesc}>
            検証用の患者を作成しました（{created.length} 件）。
          </Typography>
        )}
      </Stack>
    </PageScaffold>
  )
}
